/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Grid } from '@mui/material';
import { CheckBoxComp, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { AccessRoleDTO, AccessRoleFilterDTO, ApplicationDTO, ApplicationFilterDTO, FeatureDTO, UserDTO, UserGroupDTO, ValueListDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { access } from 'fs';
import { useTranslation } from 'react-i18next';

interface IAccessRoleMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const AccessRoleMaintenance: React.FC<IAccessRoleMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [userGroupList, setUserGroupList] = useState<UserGroupDTO[]>([]);
    const [applicationList, setApplicationList] = useState<ApplicationDTO[]>([]);
    const [featureList, setFeatureList] = useState<FeatureDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [accessRoleDTO, setAccessRoleDTO] = useState<AccessRoleDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setAccessRoleDTO({
            ...accessRoleDTO,
            id: '',
            userGroupId: '',
            applicationId: '',
            featureId: '',
            allowGetAllView: data.allowGetAllView ?? true,
            allowGetById: data.allowGetById ?? true,
            allowAdd: data.allowAdd ?? true,
            allowUpdate: data.allowUpdate ?? true,
            allowDelete: data.allowDelete ?? false
        } as AccessRoleDTO);

    }, [data]);

    useEffect(() => {
        if (isOpenMaintenance) {
            handleApplicationGetAllAsync();
            handleUserGroupGetAllAsync();
            handleUserGetAllAsync();
            handleGetAccessRoleByIdAsync();

            handleGetPermission(ListId.authsphere.accessRoleId, setAccessRolePermissionDTO);
        }
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        handleFeatureGetAllAsync();
    }, [accessRoleDTO?.applicationId]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync',accessRoleFilterDTO, setActionExecuted, setLoading, undefined,  setList,);
    }, []);

    const handleUserGroupGetAllAsync = useCallback(async () => {
        const userGroupFilter = {

        };
        GenericService.GetAllViewAsync1('authsphere.userGroup', userGroupFilter, setActionExecuted, setLoading, setUserGroupList, showMessage, true);
    }, []);

    const handleApplicationGetAllAsync = useCallback(async () => {
        const applicationFilterDTO: ApplicationFilterDTO = {
            name: '',
            typeId: '',
            isLocal: true,
            companyId: '',
        };
        GenericService.GetAllViewAsync1('appsphere.application', applicationFilterDTO, setActionExecuted, setLoading, setApplicationList, showMessage, true);
    }, []);

    const handleFeatureGetAllAsync = useCallback(async () => {
        if(accessRoleDTO?.applicationId === '')
            return;

        if (accessRoleDTO?.applicationId === undefined)
            return;

        const featureFilter = {
            applicationId: accessRoleDTO?.applicationId
        };

        GenericService.GetAllAsync1('appsphere.feature', featureFilter, setLoading, setFeatureList, showMessage);
    }, [accessRoleDTO?.applicationId]);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            accessRoleId: userInfo.user.accessRoleId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetAccessRoleByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('authsphere.accessRole', data.id, setLoading, setAccessRoleDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = accessRoleDTO as AccessRoleDTO;

        if (accessRoleDTO?.id === '' || accessRoleDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('authsphere.accessRole', dto, setAccessRoleDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if(!accessRolePermissionDTO?.allowUpdate) {
                showMessage('There is no permission for this access.', 'info');
                return;
            }
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('authsphere.accessRole', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [accessRoleDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }
    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick, isClose: isOpenMaintenance },
        { id: 'close', text: 'Close', icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('acessRole.maintenance.acessRoleDetails')} //  ACESS ROLE DETAILS
                icon='rule_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='applicationId'
                                label={t('acessRole.maintenance.application')}
                                placeholder='Application'
                                value={accessRoleDTO?.applicationId}
                                setValue={setAccessRoleDTO}
                                obj={accessRoleDTO}
                                valueList={applicationList}
                                required={true}
                                hasNoneSelect={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='featureId'
                                label={t('acessRole.maintenance.feature')}
                                placeholder='Feature'
                                value={accessRoleDTO?.featureId}
                                setValue={setAccessRoleDTO}
                                obj={accessRoleDTO}
                                valueList={featureList}
                                required={true}
                                hasNoneSelect={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='userGroupId'
                                label={t('acessRole.maintenance.userGroup')}
                                placeholder='User Group'
                                value={accessRoleDTO?.userGroupId}
                                setValue={setAccessRoleDTO}
                                obj={accessRoleDTO}
                                valueList={userGroupList}
                                required={true}
                                hasNoneSelect={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='AllowGetAllView'
                                label={t('acessRole.maintenance.allowGetAllView')}
                                setValue={setAccessRoleDTO}
                                objDTO={accessRoleDTO}
                                defaultChecked={accessRoleDTO?.allowGetAllView}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='AllowGetById'
                                label={t('acessRole.maintenance.allowGetById')}
                                setValue={setAccessRoleDTO}
                                objDTO={accessRoleDTO}
                                defaultChecked={accessRoleDTO?.allowGetById}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='AllowAdd'
                                label={t('acessRole.maintenance.allowAdd')}
                                setValue={setAccessRoleDTO}
                                objDTO={accessRoleDTO}
                                defaultChecked={accessRoleDTO?.allowAdd}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='AllowUpdate'
                                label={t('acessRole.maintenance.allowUpdate')}
                                setValue={setAccessRoleDTO}
                                objDTO={accessRoleDTO}
                                defaultChecked={accessRoleDTO?.allowUpdate}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='AllowDelete'
                                label={t('acessRole.maintenance.allowDelete')}
                                setValue={setAccessRoleDTO}
                                objDTO={accessRoleDTO}
                                defaultChecked={accessRoleDTO?.allowDelete}
                                disabled={false}
                            />
                        </Grid>
                        {accessRoleDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label={t('acessRole.maintenance.allowGetById')}
                                        value={accessRoleDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label={t('acessRole.maintenance.createdBy')}
                                        value={userList.find(x => x.id === accessRoleDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label={t('acessRole.maintenance.creationDateTime')}
                                        value={formatDateTime(String(accessRoleDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label={t('acessRole.maintenance.updatedBy')}
                                        value={userList.find(x => x.id === accessRoleDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label={t('acessRole.maintenance.updateDateTime')}
                                        value={formatDateTime(String(accessRoleDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>

                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};
